import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from '../styled';

interface PriceRow {
    price: string;
}

const PriceRow = ({ price }: PriceRow) => {
    const { t } = useTranslation();

    return (
        <S.SubscriptionCardRow>
            <Text>{t('basics.price')}</Text>
            <Text dataLocator="subscriptionPrice">{price}</Text>
        </S.SubscriptionCardRow>
    );
};

export default PriceRow;
